import React from 'react';
import {SkeletonText} from '@carbon/react';
import './TableOfContentsSkeleton.scss';

interface ITOCSkeletonProps {
    className?: string;
    title?: string;
}

/**
 * Skeleton loader for Table of Contents
 * Displays a loading state that matches the structure of the actual TOC
 */
const TableOfContentsSkeleton: React.FC<ITOCSkeletonProps> = ({
    className = 'table-of-contents',
    title = 'Table of Contents'
}) => {
    return (
        <nav className={`${className} ${className}--skeleton`}>
            <h2>{title}</h2>
            <ul>
                {/* 4 main chapters */}
                {[...Array(4)].map((_, mainIndex) => (
                    <React.Fragment key={mainIndex}>
                        <li className='toc-item'>
                            <SkeletonText width='60%' />
                        </li>
                        {/* Show children for Introduction (3 items) and County (10 items) */}
                        {(mainIndex === 0 || mainIndex === 2) && (
                            <>
                                {[...Array(mainIndex === 0 ? 3 : 10)].map((_, subIndex) => (
                                    <li
                                        key={subIndex}
                                        className='toc-subitem'
                                        style={{marginLeft: '24px'}}
                                    >
                                        <SkeletonText width='50%' />
                                    </li>
                                ))}
                            </>
                        )}
                    </React.Fragment>
                ))}
            </ul>
        </nav>
    );
};

export default TableOfContentsSkeleton;
